<template>
  <div id="container">
    <form autocomplete="off">
      <label for="username">Логин:</label>
      <input class="creds" type="text" name="username" @input="onInputUsername" :value="username">
      <label for="password">Пароль:</label>
      <input class="creds" type="password" name="password" @input="onInputPassword" :value="password">
      <div id="lower">
        <input type="submit" value="Войти" @click="login">
      </div>
    </form>
    <br>
    <div v-if="error" id="error">{{ error }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import router from '../router';

export default {
  created() {
    if (this.isAuthenticated) {
      router.replace(`/${this.role}`);
    }
  },
  data() {
    return {
      username: '',
      password: '',
    }
  },
  computed: mapGetters(['isAuthenticated', 'role', 'roleId', 'error']),
  methods: {
    ...mapActions(['auth']),
    ...mapMutations(['setSid', 'setClubId']),
    onInputUsername(event) {
      this.username = event.target.value;
    },
    onInputPassword(event) {
      this.password = event.target.value;
    },
    async login(event) {
      event.preventDefault();

      await this.auth({ username: this.username, password: this.password });

      console.log(this.roleId);

      this.setClubId(this.roleId);

      router.replace(`/club/invoice/list`);
    },
  }
}
</script>

<style scoped>
body {
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  color: #444;
  background: #f0f0f0;
}

#container {
  position: fixed;
  width: 340px;
  height: 280px;
  top: 50%;
  left: 50%;
  margin-top: -140px;
  margin-left: -170px;
  background: #fff;
  border-radius: 5px;
  border: 1.2px solid #ccc;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

form {
  margin: 0 auto;
  margin-top: 20px;
}

label {
  color: #555;
  display: block;
  margin-left: 20px;
  padding-top: 10px;
  font-size: 14px;
  float: left;
}

input {
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-size: 12px;
  outline: none;
}

.creds {
  color: #777;
  padding-left: 10px;
  margin: 10px;
  margin-top: 12px;
  margin-left: 10px;
  width: 289px;
  height: 35px;
  border: 1px solid #c7d0d2;
  border-radius: 2px;
  /*box-shadow: inset 0 1.5px 3px rgba(190, 190, 190, .4), 0 0 0 5px #f5f7f8;*/
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.creds:hover {
  border: 1px solid #b6bfc0;
}

.creds:focus {
  border-color: rgb(81, 167, 232) !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.075) inset, 0px 0px 5px rgba(81, 167, 232, 0.5);
  border: 1px solid #a8c9e4;
}

#lower {
  background: #e0edf8;
  width: 100%;
  height: 59px;
  margin-top: 20px;
  border-top: 1px solid #ccc;
  border-radius: 0px 0px 5px 5px;
}

.check {
  margin-left: 3px;
  font-size: 11px;
  color: #444;
  text-shadow: 0 1px 0 #fff;
}

input[type='submit'] {
  float: right;
  margin-right: 14px;
  margin-top: 14px;
  width: 80px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;

  background-color: #acd6ef;
  background-image: linear-gradient(to top, #acd6ef 0%, #6ec2e8 100%);

  border-radius: 30px;
  border: 1px solid #66add6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

input[type='submit']:hover {
  background-image: linear-gradient(to top, #b6e2ff 0%, #6ec2e8 100%);
}

input[type='submit']:active {
  background-image: linear-gradient(to top, #6ec2e8 0%, #b6e2ff 100%);
}

#error {
  color: #db4c4c;
  font-weight: normal;
  font-size: 0.8em;
  text-align: center;
}

#logout {
  color: #6ec2e8;
  text-align: center;
  font-weight: bold;
}

.out-sys-msg {
  padding-top: 4px;
  padding-bottom: 6px;
  background: #6ec2e8 no-repeat center center;
  display: block;
  box-shadow: 0 1px 2px #ccc;
  font-size: 16px;
  color: #fff;
  text-align: center;
  font-family: Verdana, sans-serif;
}
</style>
